import { render } from "./demystifying-game-persistence.vue?vue&type=template&id=034751aa"
import script from "./demystifying-game-persistence.vue?vue&type=script&lang=ts"
export * from "./demystifying-game-persistence.vue?vue&type=script&lang=ts"
script.render = render

export default script